const translations = {
    ac: 'Ac',
    carrier: 'Carrier',
    totalAcresApplied: 'Total Acres Applied',
    totalProductUsed: 'Total Product Used'
};

export default translations;
